import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import "./component-styles.scss";
import CallModal from "../../DoctorDashboard/CallModal";
import AppointmentJoinModal from "./modal-appointment-join";
import { Badge } from "react-bootstrap";
import CallEndModal from "../../DoctorDashboard/modal-end-call";
import PEMShareContentPopUp from "../../PEM";
import CloseOngoingConsultModal from "../../DoctorDashboard/modal-close-ongoing-consult";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";

function NextAppointmentWidget(props) {
  const { handleRatingPopup, handleEndCall } = props;
  const [isPartialDoctor, setIsPartialDoctor] = useState("false");
  const [nextAppointment, setNextAppointment] = useState(null);
  const [showCallPatientModal, setShowCallPatientModal] = useState(false);
  const [isAudioCall, setIsAudioCall] = useState(false);
  const [showJoinAppointmentModal, setShowJoinAppointmentModal] =
    useState(false);
  const [showCallEndModal, setShowCallEndModal] = useState(false);
  const [showPemModal, setShowPemModal] = useState(false);

  const [ongoingAppointment, setOngoingAppointment] = useState({});
  const [showCloseOngoingConsultModal, setShowCloseOngoingConsultModal] =
    useState(false);
  let history = useHistory();

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  useEffect(() => {
    setIsPartialDoctor(props.is_partial_doctor);
  }, [props.is_partial_doctor]);

  useEffect(() => {
    getActiveCardDetails();
  }, [props.clinicId]);

  useEffect(() => {
    if (props.renderNextAppointmentApi) {
      getActiveCardDetails();
    }
  }, [props.renderNextAppointmentApi]);

  function getActiveCardDetails() {
    if (props.clinicId || props.clinicId === null) {
      let payload = {};
      payload["doctor_id"] = userId;
      payload["appointment_date"] = moment().format("YYYY-MM-DD");
      if (props?.clinicId && props?.clinicId !== null) {
        payload["clinic_id"] = props?.clinicId;
      }
      afterLoginApiAxios
        .post(
          "/doctor/get-active-card-details-rev1",
          { ...payload },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("id_token"),
            },
          }
        )
        .then((response) => {
          if (response.data) {
            if (response.data.statusCode === 200) {
              setNextAppointment(response.data.data);
              if (props?.getNextAppointmentCallback) {
                props.getNextAppointmentCallback(response.data.data);
              }
            } else {
              setNextAppointment(null);
              props.getNextAppointmentCallback &&
                props.getNextAppointmentCallback();
            }
          } else {
            // TODO: Error handling and logging
          }
        })
        .catch((err) => C2CConsole.log(err));
    }
  }

  function renderAppointmentType(appointmentType) {
    switch (appointmentType) {
      case "in-clinic":
        return <span>In-Clinic</span>;
      case "online":
        return <span>Online</span>;
      default:
        return "";
    }
  }

  function renderConsultationType(
    appointmentType,
    consultationType,
    procedureName
  ) {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
    switch (consultationType) {
      case "regular":
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "followup":
        return <span>{appointmentTypeText + " Follow-Up"}</span>;
      case "procedure":
        return <span>{procedureName}</span>;
      case "instant":
        return <span>Instant</span>;
      default:
        return "";
    }
  }
  function joinVideoCall() {
    history.push({
      pathname: "/clinic/video",
      state: {
        app_id: {
          // this is required as video component requires these properties
          // TODO: to be optimized once video render logic is rewritten
          id: nextAppointment.appointment_id,
          patient_id: nextAppointment.patient_id,
          patient_account_id: nextAppointment.patient_account_id,
          patient_name: nextAppointment.patient_name,
          patient_dob: nextAppointment.patient_dob,
          phone_no: nextAppointment.patient_phone_no,
          patient_city: nextAppointment.patient_city,
          first_name: nextAppointment.doctor_first_name,
          last_name: nextAppointment.doctor_last_name,
          degree: nextAppointment.degree,
          patient_gender: nextAppointment.patient_gender,
          appointment_date: nextAppointment.appointment_date,
          appointment_start_date_time:
            nextAppointment.appointment_start_date_time,
          appointment_end_date_time: nextAppointment.appointment_end_date_time,
          start_time: nextAppointment.appointment_start_time,
          end_time: nextAppointment.appointment_end_time,
          doctor_id: userId,
          in_progress:
            nextAppointment?.meeting_status?.toString() === "1" ? true : false,
        },
        is_audio: true,
        is_video: isAudioCall ? false : true,
      },
    });
  }
  function clickHandler() {
    setShowCallPatientModal(true);
  }

  function checkJoinAlert() {
    afterLoginApiAxios
      .post(
        "/user/check-joining-alert",
        { meeting_id: nextAppointment?.appointment_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.data?.statusCode === 200) {
            if (
              response?.data?.appointment_data?.data &&
              response?.data?.appointment_data?.ongoing_appointment
            ) {
              setOngoingAppointment(response?.data?.appointment_data?.data);
              setShowCloseOngoingConsultModal(true);
            } else if (response.data?.data?.show_pop_up) {
              setShowJoinAppointmentModal(true);
            } else {
              joinVideoCall();
            }
          } else {
            // TODO: Error handling and logging
            joinVideoCall();
          }
        } else {
          joinVideoCall();
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  const pemCloseBtnCallback = () => {
    afterLoginApiAxios
      .post(
        "doctor/end-meeting",
        {
          appointment_id: nextAppointment?.appointment_id,
          is_manual_end: true,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response) {
          var responseData = response.data;
          if (responseData) {
            if (response.data.statusCode == 200) {
              setShowPemModal(false);
              localStorage.setItem("openStarRatingPopups", true);
              handleRatingPopup();
              handleEndCall();
            } else {
              setShowPemModal(false);
              handleEndCall();
            }
          }
        }
      })
      .catch((error) => {
        // alert(error)
      });
  };

  if (
    (isPartialDoctor && isPartialDoctor.toLowerCase() !== "false") ||
    nextAppointment === null
  ) {
    return (
      <div
        className="p-3 next-appointment-widget no-data no_data_cont d-flex"
        style={{ backgroundColor: "#fff" }}
        id="doctor_card"
      >
        <h4 className="m-0 text-center no-data justify-content-center align-self-center">
          No Appointments
        </h4>
      </div>
    );
  } else {
    return (
      <>
        <div
          className="next-appointment-widget"
          style={{ backgroundColor: "#fff" }}
          id={`${
            (isPartialDoctor && isPartialDoctor.toLowerCase() !== "false") ||
            nextAppointment === null
              ? ""
              : "doctor_card"
          }`}
        >
          {" "}
          {/**p-3 */}
          <CallModal
            openView={showCallPatientModal}
            closeView={() => {
              setShowCallPatientModal(false);
            }}
            modalCloseView={() => {
              setShowCallPatientModal(false);
            }}
            appointment_id={nextAppointment.appointment_id}
            patientName={nextAppointment.patient_name}
          />
          <div className="row m-0 px-3 pt-3">
            {nextAppointment?.meeting_status === "1" ? (
              <h5 className="col-10 pl-2 m-0">
                Call Status :{" "}
                <Badge className="py-1 px-2 mx-2 tag_style">In-Progress</Badge>
              </h5>
            ) : (
              <h5 className="col-10 pl-2 m-0">Go live with patient</h5>
            )}
            {/**pl-0 */}
            <div
              className="call-icon-div cursor-pointer"
              onClick={clickHandler}
            >
              <h4 data-tooltip="Call Patient" data-tooltip-conf="bottom">
                <i className="fa fa-phone call-icon" aria-hidden="true"></i>
              </h4>
            </div>
          </div>
          <div className="custom-border"></div>
          <div className="px-3 pb-3">
            <div className="row pl-2 mt-3 name_date_heading">
              <div className="col-6">
                <span>Patient Name</span>
              </div>
              <div className="col-6">
                <span>Date &amp; Time</span>
              </div>
            </div>
            <div className="row pl-2 name_date_display">
              <div className="col-6 text-break">
                <strong>{nextAppointment.patient_name}</strong>
              </div>
              <div className="col-6">
                <strong>
                  {nextAppointment.appointment_date != "" &&
                    moment(nextAppointment.appointment_date).format(
                      "MMM DD YYYY"
                    )}
                  ,&nbsp; {""}
                  {nextAppointment.appointment_start_time != "" &&
                    moment(
                      nextAppointment.appointment_start_time,
                      "hh:mm:ssZ"
                    ).format("hh:mm A")}
                </strong>
              </div>
            </div>
            {nextAppointment.appointment_type !== "in-clinic" ? (
              <div className="row text-center mt-3">
                <div className="col-12">
                  {localStorage.getItem("user_type") != "staff" ? (
                    <>
                      {nextAppointment?.meeting_status === "1" ? (
                        <span>
                          <button
                            className="btn btn-sm btn-tertiary rounded-pill mr-2 pt-2 pb-2"
                            onClick={() => {
                              setShowCallEndModal(true);
                            }}
                          >
                            End Call
                          </button>
                          <button
                            className="btn btn-sm btn-primary rounded-pill ml-2 pt-2 pb-2"
                            onClick={() => {
                              joinVideoCall();
                            }}
                          >
                            Rejoin Call
                          </button>
                        </span>
                      ) : (
                        <span>
                          <button
                            className="btn btn-sm btn-tertiary rounded-pill mr-2 pt-2 pb-2"
                            onClick={() => {
                              setIsAudioCall(true);
                              checkJoinAlert();
                            }}
                          >
                            Join with Audio
                          </button>
                          <button
                            className="btn btn-sm btn-primary rounded-pill ml-2 pt-2 pb-2"
                            onClick={() => {
                              setIsAudioCall(false);
                              checkJoinAlert();
                            }}
                          >
                            Join with Video
                          </button>
                        </span>
                      )}
                    </>
                  ) : (
                    <span>
                      <button
                        type="button"
                        className="btn btn-sm btn-tertiary rounded-pill mr-3"
                        disabled
                      >
                        Join with Audio
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-primary rounded-pill"
                        disabled
                      >
                        Join with Video
                      </button>
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <div className="row pl-2 mt-3">
                <div className="col-12">
                  <p className="mb-0 name_date_heading">
                    <span>Consultation</span>
                  </p>
                  <p className="font-weight-bold mt-1 mb-0">
                    {renderAppointmentType(nextAppointment.appointment_type)}
                    {" : "}
                    {renderConsultationType(
                      nextAppointment.appointment_type,
                      nextAppointment.consultation_type,
                      nextAppointment.procedure_name
                    )}
                  </p>
                </div>
              </div>
            )}
          </div>
          {/* </div> */}
        </div>
        <AppointmentJoinModal
          appointment={nextAppointment}
          doctor_id={props.doctor_id}
          openView={showJoinAppointmentModal}
          closeView={() => {
            setShowJoinAppointmentModal(false);
          }}
          joinVideoCallback={joinVideoCall}
        />

        <CallEndModal
          showCallEndModal={showCallEndModal}
          closeCallEndModal={() => {
            setShowCallEndModal(false);
          }}
          handleYes={() => {
            setShowCallEndModal(false);
            setShowPemModal(true);
          }}
        />

        {showPemModal && (
          <PEMShareContentPopUp
            patientId={nextAppointment?.patient_id}
            appointment_id={nextAppointment?.appointment_id}
            pemCloseBtnCallback={pemCloseBtnCallback}
            skipBtn={true}
          />
        )}
        {showCloseOngoingConsultModal && (
          <CloseOngoingConsultModal
            appointment_id={ongoingAppointment.appointment_id}
            patient_name={ongoingAppointment.patient_name}
            consultation={renderConsultationType(
              ongoingAppointment.appointment_type,
              ongoingAppointment.consultation_type,
              ongoingAppointment.procedure_name
            )}
            openView={showCloseOngoingConsultModal}
            closeView={() => {
              setShowCloseOngoingConsultModal(false);
            }}
            refreshAppointmentsMethod={props.refreshAppointmentsMethod}
            joinVideoCallback={joinVideoCall}
          />
        )}
      </>
    );
  }
}

export default NextAppointmentWidget;
